'use strict';

module.exports = {
    rtlsWarning: 'RTLS-Warning',
};
